import * as React from "react"

function SvgComponent(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={31.05}
      height={46.604}
      viewBox="0 0 31.05 46.604"
      {...props}
    >
      <path
        data-name="Path 10877"
        d="M31.05 15.522a15.525 15.525 0 10-23.387 13.4v5.024a2.438 2.438 0 002.4 2.391h10.822a2.349 2.349 0 002.3-2.391v-4.935a15.5 15.5 0 007.865-13.489zm-25.1-2.588a1.255 1.255 0 01-1.164-1.721 11.6 11.6 0 016.46-6.463 1.254 1.254 0 11.932 2.329 9.092 9.092 0 00-5.067 5.067 1.255 1.255 0 01-1.165.787z"
      />
      <path
        data-name="Path 10878"
        d="M21.943 38.844H9.009a1.306 1.306 0 00-1.346 1.25v.078a1.373 1.373 0 001.346 1.333h1.375a5.172 5.172 0 0010.344 0h1.217a1.284 1.284 0 001.239-1.328v-.083a1.217 1.217 0 00-1.241-1.25z"
      />
    </svg>
  )
}

export default SvgComponent
